import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Ijukebox } from '@typings/setting/jukebox.interface';
import Theme from '@styles/Theme';

const ListWrap = styled.div`
  font-size: 12px;
  background-color: var(--cardBackgroundColor);
  padding: 12px 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
const ListItem = styled.button`
  padding: 8px 12px;
  display: flex;
  justify-content: space-between;
  border-radius: var(--cardBorderRadius);
  backdrop-filter: blur(10px);
  ${Theme.shadow.card}
  color: var(--textColor);
  font-size: 12px;

    
    &:hover {
      background: var(--inkColor);
      cursor: var(--hoverCursorURL), pointer;
  }
`;

function getAudioDuration(url: string): Promise<number> {
  return new Promise((resolve, reject) => {
    const audio = new Audio();
    audio.src = url;
    audio.preload = 'metadata';
    audio.addEventListener('loadedmetadata', () => {
      resolve(audio.duration);
    });
    audio.addEventListener('error', reject);
  });
}

function formatTime(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${s < 10 ? '0' + s : s}`;
}

type Props = {
  playlist: any[];
  currentIndex: number;
  setCurrentIndex: any;
  jukeboxData: Ijukebox | null | undefined;
  style?: React.CSSProperties;
};
function AllPlayList({
  jukeboxData,
  playlist,
  currentIndex,
  setCurrentIndex,
  style,
}: Props) {
  const [durations, setDurations] = useState<{ [url: string]: number }>({});
  useEffect(() => {
    let isMounted = true; // ✅ 이 플래그로 mount 상태 추적

    const urlsToLoad = playlist
      .map((track) => track.file.url)
      .filter((url) => url && !durations[url]);

    if (!urlsToLoad.length) return;

    Promise.allSettled(
      urlsToLoad.map((url) =>
        getAudioDuration(url).then((duration) => ({ url, duration })),
      ),
    ).then((results) => {
      if (!isMounted) return; // ✅ 이미 unmounted면 setState 막기

      const newDurations: { [url: string]: number } = {};
      results.forEach((result) => {
        if (result.status === 'fulfilled') {
          const { url, duration } = result.value;
          newDurations[url] = duration;
        }
      });
      setDurations((prev) => ({ ...prev, ...newDurations }));
    });

    return () => {
      isMounted = false; // ✅ cleanup: 컴포넌트 unmount 시 플래그 꺼줌
    };
  }, [playlist]);

  const { textColor, subTextColor, backgroundColor, lineColor, cardColor } = jukeboxData?.themeSet || {};

  return (
    <ListWrap
      style={{
        ...style,
        backgroundColor: backgroundColor,
      }}
    >
      {playlist.map((track, i) => {
        const isCurrent = i === 0; // 회전된 리스트의 첫 번째가 항상 현재곡
        const duration = durations[track.file.url];

        return (
          <ListItem
            style={{
              border: `1px solid ${lineColor}`,
              backgroundColor: cardColor,
              color: textColor,

            }}
            key={i}
            className={isCurrent ? 'playing' : ''}
            onClick={() => setCurrentIndex(i)}
          >
            <div>
              <b> {i + 1}</b> &nbsp; <span>{track.title}</span>
            </div>
            {duration && (
              <span
                style={{
                  fontSize: 10,
                  color: subTextColor,
                }}
              >
                {formatTime(duration)}
              </span>
            )}
          </ListItem>
        );
      })}
    </ListWrap>
  );
}

export default AllPlayList;
